import {
  ApiPostDwhSettingsByBridgeIdResponse,
  ApiErrorResponse,
} from 'BackendApi'
import { getRandomExampleHeader } from '@app/api/utils/mock'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { endpoints } from '@app/api/config'
import { useMutation } from 'react-query'

type PostDwhSettingsByBridgeIdParams = {
  bridgeId: string
}


const postDwhSettingsByBridgeId = async ({
  bridgeId,
}: PostDwhSettingsByBridgeIdParams): Promise<ApiPostDwhSettingsByBridgeIdResponse> => {
  const apiResponse = await apiAuthClient.post(
    endpoints.postDwhSettingsByBridgeId({ bridgeId }),
    undefined,
    {
      headers: {
        ...getRandomExampleHeader(['example-1']),
      },
    }
  )
  return apiResponse.data
}

export const usePostDwhSettingsByBridgeId = () =>
  useMutation<
    ApiPostDwhSettingsByBridgeIdResponse,
    ApiErrorResponse,
    PostDwhSettingsByBridgeIdParams
  >(postDwhSettingsByBridgeId)
